module.exports = __webpack_public_path__ + "img/8.a6f42386.jpg";